import { usePostDeliverObject } from '../api/deliver-object-api/deliver-object-api';
import type { DeliverObjectDto } from '../api/model';

export const usePostDeliverObjectCreate = (options?: any) => {
  return usePostDeliverObject(options);
};